
import AttendanceByTimeSheetGraph from './attendanceByTimeSheetGraph'
import React, { useEffect, useState } from 'react'

export const TimeSheetGraph = ({ attendanceOverview, selectedOption, startDate, endDate }) => {

    return (
        <div style={{ width: "100%", height: "100%", background: "#FFFFFF", borderRadius: 6, marginTop: "20px" }}>
            <div className='m-t-40 m-l-20' style={{ height: "100%", }}>
                <AttendanceByTimeSheetGraph attendanceOverview={attendanceOverview} type={selectedOption} startDate={startDate} endDate={endDate} />
            </div>
        </div>
    )
}